/**
 * Calculate totals from detail rows based on DetailTab columns
 * Uses actual field names from don-hang-mua-trong-nuoc DetailTab
 */
export const calculateTotals = (detailRows: MuaHangRecord[] = []) => {
  let t_so_luong = 0;
  let t_cp = 0;
  let t_tien = 0;
  let t_thue = 0;
  let t_tt = 0;

  detailRows.forEach((row: MuaHangRecord) => {
    const sl = Number(row.so_luong) || 0;
    const thue = Number(row.thue_nt) || 0;
    const tong_tien = Number(row.tien_nt) || 0;

    t_so_luong += sl;
    t_thue += thue;
    t_tien += tong_tien;
    t_tt += tong_tien + thue;
  });

  return {
    t_so_luong,
    t_cp,
    t_cp_nt: t_cp,
    t_tien_nt: t_tien,
    t_tien,
    t_thue_nt: t_thue,
    t_thue,
    t_tt_nt: t_tt,
    t_tt
  };
};

/**
 * Example usage and test cases for the calculation functions
 *
 * Test the percentage calculations:
 * - calculateTaxAmount(1000, 10) should return 100 (10% of 1000)
 * - calculateTaxAmount(500, 5.5) should return 27.5 (5.5% of 500)
 * - calculateTaxRate(1000, 100) should return 10 (100 is 10% of 1000)
 * - calculateTaxRate(500, 27.5) should return 5.5 (27.5 is 5.5% of 500)
 */
